// Custom styling can be passed to options when creating an Element.
const CARD_ELEMENT_OPTIONS = {
    // hidePostalCode: true,
    style: {
        base: {
            color: '#32325d',
            fontFamily: '"ProximaNova", ProximaNova, sans-serif',
            fontSmoothing: 'antialiased',
            fontSize: '16px',
            '::placeholder': {
                color: '#aab7c4',
            },
            // height: '28px',
        },
        invalid: {
            color: '#fa755a',
            iconColor: '#fa755a',
        },
    },
};

export default CARD_ELEMENT_OPTIONS;
